module.exports = __webpack_public_path__ + "img/photo-example.cacb6e94.jpg";